import { render } from "./cardsGeralRedirectionsComponent.vue?vue&type=template&id=02af410d"
import script from "./cardsGeralRedirectionsComponent.vue?vue&type=script&lang=js"
export * from "./cardsGeralRedirectionsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__